var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, createContext } from 'react';
import { getNamespacedLogger } from './helpers';
var DEFAULT_CONTEXT = {
    namespace: 'untagged',
    log: getNamespacedLogger('untagged'),
};
var Context = createContext(DEFAULT_CONTEXT);
function Provider(_a) {
    var namespace = _a.namespace, children = _a.children;
    var context = useMemo(function () { return ({
        log: getNamespacedLogger(namespace),
        namespace: namespace,
    }); }, [namespace]);
    return _jsx(Context.Provider, __assign({ value: context }, { children: children }), void 0);
}
export { Context };
export default Provider;
//# sourceMappingURL=Provider.js.map